export default Object.freeze({
  Completed: {
    value: 'Completed',
    text: 'Completed',
  },
  Incomplete: {
    value: 'Incomplete',
    text: 'Scheduled',
  }
});
